import { FC } from 'react';
import { useHistory } from 'react-router';

import { EvNoTenant } from '@evinced-private/ui-common';

import { EXTERNAL_HUBSPOT_SOURCE } from 'src/consts/products-consts';

import { getHomepagePath, getSignupPath } from '../../helpers/RoutesHelper';
import { useUserTenant } from '../../providers/userTenantProvider/UserTenantProvider';
import { getUserEmail } from '../../services/AuthenticationService';

export const NoTenantPage: FC = () => {
	const { tenant } = useUserTenant();
	const history = useHistory();
	if (tenant) {
		history.push(getHomepagePath());
		return null;
	}
	return (
		<EvNoTenant
			userEmail={getUserEmail()}
			externalHubspotSource={EXTERNAL_HUBSPOT_SOURCE}
			portalId={import.meta.env.VITE_HUBSPOT_API_KEY}
			onSignUpWithEmail={() => history.push(getSignupPath())}
		/>
	);
};
